import { Flex } from '@radix-ui/themes';
import { PulpLogo } from '@/components/layout';

/** v90 s-splash-entry — brand mark while app loads. */
export function SplashScreen() {
  return (
    <Flex
      align="center"
      justify="center"
      flexGrow="1"
      minHeight="0"
      height="100%"
      id="initial-spinner"
    >
      <PulpLogo width={80} />
    </Flex>
  );
}
